/* tslint:disable */
/* eslint-disable */
/**
 * RoadFootage.API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 *
 * @export
 */
export const StaffMediaProblemKind = {
    Failed: 'Failed',
    Threat: 'Threat'
};
export function StaffMediaProblemKindFromJSON(json) {
    return StaffMediaProblemKindFromJSONTyped(json, false);
}
export function StaffMediaProblemKindFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
export function StaffMediaProblemKindToJSON(value) {
    return value;
}
